module.exports = __webpack_public_path__ + "static/media/CAFlagicoi.d6ff061e.png";